export default {
  indicator: {
    display: "none",
  },
};
